import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./components/Layout";
import DashboardRouter from "./pages/DashboardRouter";
import ProtectedRoute from "./context/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import RoleGuard from "./context/RoleGuard";
import TutorsPage from "./pages/TutorsPage";
import StudentsPage from "./pages/StudentsPage";
import Sessions from "./pages/Sessions";
import Logger from "./pages/Logger";
import AuditLogs from "./pages/AuditLogs";
import ResetPassword from "./pages/ResetPassword";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes with persistent layout */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard logic - decides which dashboard to show based on role/status */}
            <Route path="/dashboard" element={<DashboardRouter />} />

            {/* Guarded pages  */}
            <Route
              path="/tutors"
              element={
                <RoleGuard allowedRoles={["admin", "coordinator", "viewer"]}>
                  <TutorsPage />
                </RoleGuard>
              }
            />

            <Route
              path="/logger"
              element={
                <RoleGuard allowedRoles={["tutor"]}>
                  <Logger />
                </RoleGuard>
              }
            />

            <Route
              path="/students"
              element={
                <RoleGuard allowedRoles={["admin", "coordinator", "viewer"]}>
                  <StudentsPage />
                </RoleGuard>
              }
            />

            <Route
              path="/sessions"
              element={
                <RoleGuard
                  allowedRoles={["admin", "coordinator", "viewer", "tutor"]}
                >
                  <Sessions />
                </RoleGuard>
              }
            />

            <Route
              path="/audit-logs"
              element={
                <RoleGuard allowedRoles={["admin", "coordinator", "viewer"]}>
                  <AuditLogs />
                </RoleGuard>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
